import { render, staticRenderFns } from "./AbandonnedLandingPage.vue?vue&type=template&id=5f0753ec&scoped=true&"
import script from "./AbandonnedLandingPage.vue?vue&type=script&lang=js&"
export * from "./AbandonnedLandingPage.vue?vue&type=script&lang=js&"
import style0 from "./AbandonnedLandingPage.vue?vue&type=style&index=0&id=5f0753ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0753ec",
  null
  
)

export default component.exports